// TODO: create new library for Editor/DnD
import {createStore, useStore} from 'zustand'

import {BlockStatusActionEnum, useFragmentHelpers, useSetBlockLockMutation} from '@sdox/api'

import {useDocumentVersionId} from '../hooks/paramHooks'

import type {PanelFragment, XcNwBlockFragment} from '@sdox/api'

let intervalId: ReturnType<typeof setInterval> | undefined = undefined

export interface UpdateBlockDialogMeta {
  block: XcNwBlockFragment
  panelId: PanelFragment['id']
}

export interface UpdateBlockDialogState {
  meta?: UpdateBlockDialogMeta
  loading: boolean
}

// We use a vanilla store here, so we can easily dispatch changes form drag-and-drop monitors
// We then create the store hook for usage in components
// https://docs.pmnd.rs/zustand/guides/typescript#bounded-usestore-hook-for-vanilla-stores
export const updateBlockDialogStore = createStore<UpdateBlockDialogState>()(() => ({
  meta: undefined,
  loading: false,
}))

export function useUpdateBlockDialogStore<T>(selector?: (state: UpdateBlockDialogState) => T) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(updateBlockDialogStore, selector!)
}

export const useOpenBlockUpdateDialog = () => {
  const documentVersionId = useDocumentVersionId()
  const [setBlockLockMutation] = useSetBlockLockMutation()
  const {updateBlockLockStatus} = useFragmentHelpers()

  const lock = async (
    blockId: string,
    action: BlockStatusActionEnum,
  ) => {
    await setBlockLockMutation({
      variables: {blockId, documentVersionId, lockStatus: {action}},
      update: (_, {data}) => {
        updateBlockLockStatus(blockId, data?.setBlockLock ?? null)
      },
    })
  }

  return (meta: UpdateBlockDialogMeta) => {
    clearInterval(intervalId)
    lock(meta.block.id, BlockStatusActionEnum.Update).catch((error) => { console.log(error) })
    intervalId = setInterval(async () => {
      lock(meta.block.id, BlockStatusActionEnum.Update).catch((error) => { console.log(error) })
    }, 1000 * 20)
    updateBlockDialogStore.setState({meta})
  }
}

export const useCloseBlockUpdateDialog = () => {
  const documentVersionId = useDocumentVersionId()
  const [setBlockLockMutation] = useSetBlockLockMutation()
  const {updateBlockLockStatus} = useFragmentHelpers()

  return () => {
    const meta = updateBlockDialogStore.getState().meta
    // dialog is already closed
    if (!meta) return
    const blockId = meta.block.id
    updateBlockDialogStore.setState({meta: undefined})
    clearInterval(intervalId)
    setBlockLockMutation({
      variables: {blockId, documentVersionId},
      update: (_, {data}) => {
        updateBlockLockStatus(blockId, data?.setBlockLock ?? null)
      },
    }).catch((error) => { console.log(error) })
  }
}
